module.exports = __webpack_public_path__ + "img/view_more.ddc79dd8.svg";